import {useTheme} from "@material-ui/core/styles";
import darkNavLogo from "../assets/j10bot-dark.svg";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Drawer, IconButton, List, Divider, makeStyles } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";

const useStyles = makeStyles(theme => ({
  docked: { width: 240, flexShrink: 0 },
  collapsed: { width: 72, [theme.breakpoints.down("xs")]: { width: 56 } },
  paper: {
    width: 240, maxWidth: "calc(100vw - 48px)", overflow: "hidden",
    display: "flex", flexDirection: "column",
    background: theme.mode === "dark" ? "#0c1626" : "#11263c",
    ...(theme.mode==="light"?{
      color:"#d9e6f2",
      "& .MuiListItemText-root .MuiTypography-root, & .MuiAvatar-root, & .MuiListItemIcon-root, & .MuiIconButton-root":{color:"#c5d6e7 !important"},
      "& .MuiListSubheader-root":{backgroundColor:"#11263c",color:"#98b3cc !important"},
      "& .Mui-selected":{backgroundColor:"#17465b !important",borderLeftColor:"#2fc4e6"},
      "& .Mui-selected .MuiTypography-root, & .Mui-selected .MuiAvatar-root":{color:"#5bddf2 !important"},
      "& .MuiAvatar-root.active, & .MuiListItem-button:hover .MuiAvatar-root":{background:"transparent",color:"#5bddf2 !important"},
      "& .j10-connection-status":{background:"#183449",borderColor:"#37526b",color:"#dce8f4"},
      "& .j10-connection-status small, & .MuiTypography-caption":{color:"#b9ccde"},
    }:{}),
  },
  paperCollapsed: { width: 72 },
  mobilePaper: {
    height: "100%", paddingBottom: "env(safe-area-inset-bottom, 0px)",
    "@supports (height: 100dvh)": { height: "100dvh" },
  },
  header: {
    display: "flex", alignItems: "center", flexShrink: 0,
    minHeight: 64, padding: "8px", gap: 4,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  logo: { flex: 1, minWidth: 0, width: 0, maxWidth: 176, height: 40, objectFit: "contain" },
  close: { flexShrink: 0, width: 44, height: 44, color: theme.mode==="light"?"#dce8f4":theme.palette.text.primary },
  list: {
    flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden",
    WebkitOverflowScrolling: "touch", overscrollBehaviorY: "contain",
  },
  footer: { flexShrink: 0 },
}));

export default function NavigationDrawer({ open, isMobile, onClose, onOpen, logoSrc, children, footer }) {
  const classes = useStyles();
  const theme=useTheme();
  const { pathname } = useLocation();
  useEffect(() => {
    if (isMobile) onClose();
    // Only navigation or a breakpoint change should close the drawer.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, isMobile]);
  const navigate = event => {
    // Expanding a submenu must keep it open; selecting a link closes it,
    // including a link to the current page.
    if (isMobile && event.target.closest("a[href]")) onClose();
  };
  return (
    <Drawer
      className={`j10-navigation-drawer ${isMobile ? "" : `${classes.docked} ${!open ? classes.collapsed : ""}`}`}
      variant={isMobile ? "temporary" : "permanent"}
      open={open}
      onClose={onClose}
      classes={{ paper: `${classes.paper} ${!isMobile && !open ? classes.paperCollapsed : ""} ${isMobile ? classes.mobilePaper : ""}` }}
      PaperProps={{ component: "nav", "aria-label": "Menu principal" }}
    >
      <div className={classes.header}>
        {open && <img className={classes.logo} src={theme.mode==="light"?darkNavLogo:logoSrc} alt="J10 Connect" />}
        <IconButton className={classes.close} aria-label={open ? "Fechar menu de navegação" : "Abrir menu de navegação"} onClick={open ? onClose : onOpen}>
          <ChevronLeftIcon />
        </IconButton>
      </div>
      <List className={classes.list} onClick={navigate}>{children}</List>
      <Divider />
      <div className={classes.footer}>{footer}</div>
    </Drawer>
  );
}
